import type { Coordinates } from '../types'

export type GeolocationErrorCode = 'UNSUPPORTED' | 'DENIED' | 'UNAVAILABLE'

export class GeolocationRequestError extends Error {
  constructor(readonly code: GeolocationErrorCode) {
    super(code)
    this.name = 'GeolocationRequestError'
  }
}

export function requestCurrentLocation(): Promise<Coordinates> {
  if (!navigator.geolocation) return Promise.reject(new GeolocationRequestError('UNSUPPORTED'))

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => resolve({ latitude: coords.latitude, longitude: coords.longitude }),
      (error) => {
        reject(new GeolocationRequestError(error.code === error.PERMISSION_DENIED ? 'DENIED' : 'UNAVAILABLE'))
      },
      { enableHighAccuracy: true, timeout: 12_000, maximumAge: 60_000 },
    )
  })
}
